import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import type { DormantSoftwareQuery } from './type';
export const getDormantSummary = async () => {
  const res = await apiClient.GET('/v2/accesses/dormancy/summary');
  return getDataOrThrowApiError(res);
};
export const listDormantSoftware = async (params: DormantSoftwareQuery) => {
  const res = await apiClient.GET('/v2/accesses/dormancy/software', {
    params: {
      query: params
    }
  });
  return getDataOrThrowApiError(res);
};